export enum UploadParentItemType {
  businessRequest = 'businessRequest',
  partnerRequest = 'partnerRequest',
  selfResponse = 'selfResponse'
}